import { settingsParams } from '@wix/wix-vod-constants/app-settings';

export default settingsParams;
